import React, { useState } from "react";


import {
  FaBomb,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

const RESPONSIVE_CSS = `
  .dsp-hero-inner {
    width: 92% !important;
    padding: 38px 0px !important;
  }
  .dsp-hero-icon {
    width: 44px !important;
    height: 44px !important;
  }
  .dsp-hero-title {
    font-size: clamp(22px, 5vw, 34px) !important;
  }
  .dsp-hero-desc {
    font-size: clamp(13px, 2vw, 15px) !important;
    line-height: 1.8 !important;
  }
  .dsp-accordion-wrap {
    width: 92% !important;
    padding: 28px 0px 50px !important;
  }
  .dsp-accordion-header {
    padding: 14px 16px !important;
    gap: 10px !important;
  }
  .dsp-accordion-title {
    font-size: 15px !important;
  }
  .dsp-accordion-content {
    padding: 16px 18px !important;
  }
  .dsp-point-text {
    font-size: 14px !important;
  }

  @media (max-width: 600px) {
    .dsp-hero-inner {
      width: 90% !important;
      padding: 28px 0px !important;
    }
    .dsp-hero-row {
      gap: 10px !important;
      margin-bottom: 12px !important;
    }
    .dsp-hero-icon {
      width: 38px !important;
      height: 38px !important;
      border-radius: 8px !important;
    }
    .dsp-hero-icon svg {
      font-size: 17px !important;
    }
    .dsp-hero-title {
      font-size: clamp(19px, 6vw, 26px) !important;
    }
    .dsp-hero-desc {
      font-size: 13px !important;
      line-height: 1.7 !important;
    }
    .dsp-accordion-wrap {
      width: 92% !important;
      padding: 20px 0px 36px !important;
    }
    .dsp-accordion-header {
      padding: 12px 14px !important;
    }
    .dsp-accordion-title {
      font-size: 14px !important;
      line-height: 1.4 !important;
    }
    .dsp-accordion-content {
      padding: 14px 14px !important;
    }
    .dsp-point-row {
      gap: 10px !important;
      margin-bottom: 10px !important;
    }
    .dsp-point-check {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
    }
    .dsp-point-check svg {
      font-size: 9px !important;
    }
    .dsp-point-text {
      font-size: 13px !important;
      line-height: 1.6 !important;
    }
  }

  @media (max-width: 360px) {
    .dsp-hero-title {
      font-size: 18px !important;
    }
    .dsp-accordion-title {
      font-size: 13px !important;
    }
  }
`;

function DefenseSecurityPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Surveillance & Reconnaissance",
      points: [
        "Real-Time Threat Detection Agent",
        "Border Intrusion Alert Agent",
        "Drone Surveillance Analysis Agent",
        "Suspicious Behavior Detection Agent",
        "Facial Recognition Watchlist Agent",
      ],
    },

    {
      title: "Decision Intelligence",
      points: [
        "War Game Simulation Agent",
        "Tactical Strategy Optimization Bot",
        "Mission Risk Assessment Agent",
        "Battlefield Route Planner",
        "Target Identification Classifier",
      ],
    },

    {
      title: "Cybersecurity",
      points: [
        "Intrusion Detection System (IDS) Agent",
        "Secure Communication Validator",
        "Vulnerability Scanning Bot",
        "Malware Behavior Simulator Agent",
        "Cyber Threat Intelligence Bot",
      ],
    },

    {
      title: "Logistics & Operations",
      points: [
        "Military Asset Tracker",
        "Inventory Resupply Planner Agent",
        "Fuel Consumption Optimizer",
        "Equipment Fault Detector",
        "Weather-Aware Logistics Bot",
      ],
    },

    {
      title: "Training & HR",
      points: [
        "Soldier Training Simulation Agent",
        "Threat Recognition Tutor Bot",
        "AI Drill Feedback Agent",
        "Language Translation for Field Ops",
        "Psychological Fatigue Detector",
      ],
    },
  ];

  return (
    <>
      <style>{RESPONSIVE_CSS}</style>

      <div
        style={{
          background: "#22c7b8",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        {/* HERO SECTION */}
        <div
          style={{
            background: "#173b8f",
            width: "100%",
          }}
        >
          <div
            className="dsp-hero-inner"
            style={{
              width: "92%",
              maxWidth: "1300px",
              margin: "0 auto",
              padding: "38px 0px",
              boxSizing: "border-box",
            }}
          >
            <div
              className="dsp-hero-row"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
                flexWrap: "wrap",
              }}
            >
              <div
                className="dsp-hero-icon"
                style={{
                  width: "44px",
                  height: "44px",
                  background: "#22c7b8",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaBomb
                  style={{
                    color: "#ffffff",
                    fontSize: "20px",
                  }}
                />
              </div>

              <h1
                className="dsp-hero-title"
                style={{
                  color: "#ffffff",
                  fontSize: "34px",
                  fontWeight: "700",
                  margin: 0,
                  fontFamily: "Exo, sans-serif",
                  wordBreak: "break-word",
                }}
              >
                Defense & Security
              </h1>
            </div>

            <p
              className="dsp-hero-desc"
              style={{
                color: "#f2f2f2",
                fontSize: "15px",
                lineHeight: "1.9",
                maxWidth: "1000px",
                margin: 0,
              }}
            >
              This sector includes military operations, intelligence, defense R&D, border security, and surveillance systems.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div
          className="dsp-accordion-wrap"
          style={{
            width: "78%",
            maxWidth: "1050px",
            margin: "0 auto",
            padding: "28px 0px 50px",
            boxSizing: "border-box",
          }}
        >
          {sections.map((section, index) => (
            <div
              key={index}
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                marginBottom: "10px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {/* HEADER */}
              <div
                onClick={() => toggle(index)}
                className="dsp-accordion-header"
                style={{
                  padding: "14px 18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  background:
                    openIndex === index
                      ? "#173b8f"
                      : "#ffffff",
                  transition: "0.3s",
                  gap: "12px",
                  boxSizing: "border-box",
                }}
              >
                <h2
                  className="dsp-accordion-title"
                  style={{
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: "700",
                    color:
                      openIndex === index
                        ? "#ffffff"
                        : "#173b8f",
                    fontFamily: "Exo, sans-serif",
                    wordBreak: "break-word",
                    minWidth: 0,
                  }}
                >
                  {section.title}
                </h2>

                {openIndex === index ? (
                  <FaChevronUp
                    style={{
                      color: "#ffffff",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <FaChevronDown
                    style={{
                      color: "#173b8f",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                )}
              </div>

              {/* CONTENT */}
              {openIndex === index && (
                <div
                  className="dsp-accordion-content"
                  style={{
                    padding: "18px 24px",
                    background: "#ffffff",
                    boxSizing: "border-box",
                  }}
                >
                  {section.points.map((point, i) => (
                    <div
                      key={i}
                      className="dsp-point-row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        className="dsp-point-check"
                        style={{
                          width: "24px",
                          height: "24px",
                          minWidth: "24px",
                          borderRadius: "50%",
                          background: "#22c7b8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCheck
                          style={{
                            color: "#ffffff",
                            fontSize: "10px",
                          }}
                        />
                      </div>

                      <p
                        className="dsp-point-text"
                        style={{
                          margin: 0,
                          color: "#4b5563",
                          fontSize: "15px",
                          lineHeight: "1.7",
                          fontWeight: "500",
                          wordBreak: "break-word",
                        }}
                      >
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default DefenseSecurityPage;
